import { string, object, boolean, date, number } from 'yup';

const schema = object().shape({
  ownershipType: string().required('Please specify if owned or leased'),
  inspectionType: string().required('Please specify inspection type'),
  inspectionDate: date().required('Date is required'),
  yardName: string().required('Yard is required'),
  odometerReading: number()
    .required('Odometer reading is required')
    .typeError('Odometer reading must be number'),
  noDefects: boolean(),
  remarks: string(),
  conditionStatus: string()
    .required('Please select vehicle condition')
    .oneOf(['satisfactory', 'not_satisfactory'], 'Please select vehicle condition')
    .typeError('Please select vehicle condition'),
  driverName: string().required('Driver name is required'),
  signatureData: string().required('Signature is required')
});

export default schema;
